import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { ImageSkeleton, LineSkeleton } from "../../Components/Utility/Skeletons";
import { SetMetaTags } from "../../Components/Utility/setMetaTags";
import { fetchCmsMetaData } from "../../Components/Utility/cmsMetaService";

function HostSubcategory() {
  const [subCategory, setSubCategory] = useState([]);
  const [category, setCategory] = useState(null);
  const [baseUrl, setBaseUrl] = useState("");
  const location = useLocation();
  const [selectedSub, setSelectedSub] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState("");
  const [meta,setMeta] = useState();

  // ✅ fallback to localStorage
  const savedData = JSON.parse(localStorage.getItem("hostData")) || {};
  const categoryId = location.state?.categoryId || savedData.categoryId;

  const fetchSubCategory = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/get-sub-category`,
        {
          category_id: categoryId,
        }
      );
      setCategory(res.data.category);
      setSubCategory(res.data.data);
      setBaseUrl(res.data.base_url);
    } catch (error) {
      console.error("Error while fetching subcategory", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchExperience = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/host/get-host-experience`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data?.data?.sub_category_id) {
        const foundSub = subCategory.find(
          (item) => item.id === res.data.data.sub_category_id
        );
        if (foundSub) {
          setSelectedSub(foundSub);
        } else {
          setSelectedSub({ id: res.data.data.sub_category_id });
        }
      }
    } catch (error) {
      console.error("error when fetching experience", error);
    }
  };

  useEffect(() => {
    if (categoryId) {
      fetchSubCategory();
    } else {
      console.warn("No categoryId found in state or localStorage");
    }
  }, [categoryId]);

  useEffect(() => {
    if (subCategory.length > 0) {
      fetchExperience();
    }

    const existing = JSON.parse(localStorage.getItem("hostData")) || {};
    if (existing.subCategoryId) {
      const foundSub = subCategory.find((item) => item.id === existing.subCategoryId);
      if (foundSub) {
        setSelectedSub(foundSub);
      } else {
        setSelectedSub({ id: existing.subCategoryId, subcategory: existing.subCategoryName });
      }
    }
  
  }, [subCategory]);

  const handleNext = () => {
    if (!selectedSub) {
      toast.error("Please select a subcategory before proceeding.");
      return;
    }

    const existing = JSON.parse(localStorage.getItem("hostData")) || {};
    existing.categoryId = categoryId; // ✅ ensure categoryId also stored
    existing.subCategoryId = selectedSub.id;
    existing.subCategoryName = selectedSub.subcategory;
    localStorage.setItem("hostData", JSON.stringify(existing));

    navigate("/host-choose-experience", {
      state: {
        categoryId,
        subCategoryId: selectedSub.id,
        subCategoryName: selectedSub.subcategory,
      },
    });
  };

   useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("subcategory");
      setMeta(data);
    };

    loadMeta();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <section className="ser_v_araeea allpages what_experience al_bootm_spance1">
         <SetMetaTags
        title= {meta?.meta_title || "SubCategory | Weyfarin"}
        description={meta?.meta_description || "SubCategory | Weyfarin"}
      
      />

        <div className="container">
          <div className="abt_pgs_areea">
            {loading ? (
              <LineSkeleton width="300px" height="24px" margin="0 auto 20px" />
            ) : (
              <h2>How would you describe your experience?</h2>
            )}
          </div>

          <div className="categary_listst justy_centr subhostingss">
            {loading ? (
              <div className="items_bx">
                <ImageSkeleton width="150px" height="150px" borderRadius="12px" />
                <LineSkeleton width="120px" height="16px" margin="8px auto 0" />
              </div>
            ) : category ? (
              <div className="items_bx">
                <div className="mg_area_sc">
                  <img
                    src={`${baseUrl}${category.image}`}
                    alt={category.category}
                  />
                </div>
                <p>{category.category}</p>
              </div>
            ) : (
              <p>No category available</p>
            )}
          </div>

          <div className={`typ_areea sub_categry ${subCategory.length === 1 ? "singlesub" : ""}`}>
            <ul>
              {loading
                ? Array(4)
                    .fill(0)
                    .map((_, index) => (
                      <li key={index}>
                        <LineSkeleton width="200px" height="20px" margin="8px 0" />
                      </li>
                    ))
                : subCategory.length > 0
                ? subCategory.map((item) => (
                    <li
                      key={item.id}
                      onClick={() => {
                        setSelectedSub(item);
                        setErrorMsg("");
                      }}
                    >
                      <button
                        className={`sub_btn ${
                          selectedSub?.id === item.id ? "active" : ""
                        }`}
                      >
                        {item.subcategory}
                      </button>
                    </li>
                  ))
                : (
                  <li>No subcategories available</li>
                )}
            </ul>
          </div>

          {errorMsg && <div className="error-message">{errorMsg}</div>}

          <div className="rightss_links">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => navigate("/host-category")}
            >
              Back
            </button>

            <button
              type="button"
              onClick={handleNext}
              className="btn btn-primary"
            >
              Next
            </button>
          </div>
        </div>
      </section>
    </>
  );
}

export default HostSubcategory;
